import { Component, ViewChild, OnInit, AfterViewInit, Inject } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http'
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MessageService } from '../../core/services/message.service';
import { ApiService } from '../../core/services/api.service';
import { AsideComponent } from '../aside/aside.component';
import { LoadInfo } from './shared/load-info';
import { FileSystemFileEntry, FileSystemDirectoryEntry, UploadEvent } from 'ngx-file-drop';
import { DataTableComponent } from '../../shared/data-table/data-table.component';
import { Address } from '../../Models/address';
import { UpdateAddressModalComponent } from '../dialogs/dialog-update-address/dialog-update-address.component';
@Component({
  selector: 'tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsComponent implements OnInit, AfterViewInit {
  options = {
    columnTitles: ["Número de Guia", "Almacén" , "Cliente", "Fecha de Registro", "Seleccionar"],
    columnReferences: ["guide","wharehouse","client","dateCreation","actions"],
    actionButtons: { detail: false, selectable: true}
  }
  withPending = false;
  replenishment = false;
  search = {
    "warehouse":"",
    "initDate":"",
    "endDate":"",
    "client":"",
    "guide":""
  };
  generalSelection = false;
  public progress: number;
  public message: string;
  @ViewChild("tableChild") tableChild: DataTableComponent<LoadInfo>;
  openAside: boolean;
  selectedLoad: any;

  @ViewChild(AsideComponent)
  aside: AsideComponent;

  selectedFile: any;
  fileSize: any;

  constructor(private apiService: ApiService, private messageService: MessageService, public dialog: MatDialog) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    
  }

  changeSelection(tableData:any){
    for(let i = 0;i<tableData.dataSource.dataSubject._value.length;i++){
        tableData.dataSource.dataSubject._value[i].selected = this.generalSelection;
    }
    console.log(tableData.dataSource.dataSubject._value);
  }

  upload(files) {
    if (files.length === 0)
      return;

    this.selectedFile = files[0];
    console.log(this.selectedFile);
    this.fileSize = this.formatBytes(this.selectedFile.size, 2);

  }

  sendFile() {
    const formData = new FormData();
    formData.append(this.selectedFile.name, this.selectedFile);

    this.apiService.post("api/Upload/" + this.withPending + "/" + this.replenishment, formData).subscribe((response: Address[]) => {
      this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
        {
          article: 'GENERAL.MESSAGE.THE_1',
          function: 'LOAD_IMPORT.SINGLE',
          action: 'GENERAL.MESSAGE.ACTIONS.ACTION_SAVE'
        });
      this.tableChild.loadPage();
      if (response && response.length) {
        this.openDialogAddress(response);
      }
    });
  }

  openDialogAddress(address: Address[]) {
    const dialogRef = this.dialog.open(UpdateAddressModalComponent, {
      width: '1280px',
      data: address,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  public dropped(event: UploadEvent) {
    let droppedFile = event.files[0];
    // Is it a file?
    if (droppedFile.fileEntry.isFile) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        console.log(droppedFile.relativePath, file);
        this.selectedFile = file;
        this.fileSize = this.formatBytes(this.selectedFile.size, 2);
        console.log(this.selectedFile);
      });
    } else {
      const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      console.log(droppedFile.relativePath, fileEntry);
    }
  }

  formatBytes(a, b) {
    if (0 == a) return "0 Bytes";
    var c = 1024,
      d = b || 2,
      e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      f = Math.floor(Math.log(a) / Math.log(c));
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f]
  }

  searchLoad(s: any){
    let searchOb = s;
    this.tableChild.firstPage();
    this.tableChild.loadPage(searchOb);
  }

  imprSelec(table: any){
    let content = table.dataSource.dataSubject._value;
    let ids = [];
    content.forEach(element => {
      if(element.selected){
        ids.push(element.idShip);
      }
    });
    console.log(ids);
    if(ids.length>0){
      this.apiService.post('api/OrderPrint/Print',ids).subscribe((response: any) => {
        if (response) {
          window.open(response.data);
        }
      })
    }
  }
}